module.exports = __webpack_public_path__ + "static/graffiti-4de75c7d08a7abcb1634ad9e8b9c1921.jpg";